/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPhotos
// ====================================================

export interface GetPhotos_photos_archive {
  __typename: "Archive";
  /**
   * The public ID, an UUID v4
   */
  id: string;
}

export interface GetPhotos_photos_photoMetadatas_metadata {
  __typename: "Metadata";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  name: MetadataNameEnumType;
}

export interface GetPhotos_photos_photoMetadatas {
  __typename: "PhotoMetadata";
  /**
   * The ID
   */
  id: number;
  value: string | null;
  metadata: GetPhotos_photos_photoMetadatas_metadata;
}

export interface GetPhotos_photos_previews {
  __typename: "Preview";
  size: number | null;
  href: string | null;
}

export interface GetPhotos_photos {
  __typename: "Photo";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  archive: GetPhotos_photos_archive;
  /**
   * The date, fixed, of the document's creation
   */
  createdAt: GraphQL$DateTime;
  isUploaded: boolean | null;
  isLegacy: boolean | null;
  originalName: string | null;
  /**
   * get a S3 download URL
   */
  downloadUrl: string | null;
  /**
   * "PhotoMetadata.photo"'s inverse relation
   */
  photoMetadatas: GetPhotos_photos_photoMetadatas[];
  /**
   * get all supported resized previews
   */
  previews: GetPhotos_photos_previews[] | null;
}

export interface GetPhotos {
  /**
   * Retrieve the number of "Photo" nodes.
   */
  photoCount: number;
  /**
   * Retrieve a list of "Photo" nodes.
   */
  photos: GetPhotos_photos[];
}

export interface GetPhotosVariables {
  where?: PhotoWhereInput | null;
  first: number;
  orderBy?: PhotoOrderByInput[] | null;
  skip?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Photo
// ====================================================

export interface Photo_archive {
  __typename: "Archive";
  /**
   * The public ID, an UUID v4
   */
  id: string;
}

export interface Photo_photoMetadatas_metadata {
  __typename: "Metadata";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  name: MetadataNameEnumType;
}

export interface Photo_photoMetadatas {
  __typename: "PhotoMetadata";
  /**
   * The ID
   */
  id: number;
  value: string | null;
  metadata: Photo_photoMetadatas_metadata;
}

export interface Photo_previews {
  __typename: "Preview";
  size: number | null;
  href: string | null;
}

export interface Photo {
  __typename: "Photo";
  /**
   * The public ID, an UUID v4
   */
  id: string;
  archive: Photo_archive;
  /**
   * The date, fixed, of the document's creation
   */
  createdAt: GraphQL$DateTime;
  isUploaded: boolean | null;
  isLegacy: boolean | null;
  originalName: string | null;
  /**
   * get a S3 download URL
   */
  downloadUrl: string | null;
  /**
   * "PhotoMetadata.photo"'s inverse relation
   */
  photoMetadatas: Photo_photoMetadatas[];
  /**
   * get all supported resized previews
   */
  previews: Photo_previews[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ArchiveKeyType {
  CAM_LIVRAISON = "CAM_LIVRAISON",
  CAM_SUJETS = "CAM_SUJETS",
  CBG_SUJETS = "CBG_SUJETS",
  CLE_SUJETS = "CLE_SUJETS",
  FAP_BEAUTE_ARCHIVES = "FAP_BEAUTE_ARCHIVES",
  FAP_CUISINE_ARCHIVES = "FAP_CUISINE_ARCHIVES",
  FAP_DECO_ARCHIVES = "FAP_DECO_ARCHIVES",
  FATV_SUJETS = "FATV_SUJETS",
  GALA_LIVRAISON = "GALA_LIVRAISON",
  GAL_PEOPLE = "GAL_PEOPLE",
  GEO_ARCHIVES = "GEO_ARCHIVES",
  HBZ_ARCHIVE = "HBZ_ARCHIVE",
  HBZ_LIVRAISON = "HBZ_LIVRAISON",
  HBZ_SUJETS = "HBZ_SUJETS",
  MAD_SUJETS = "MAD_SUJETS",
  NEON_SUJETS = "NEON_SUJETS",
  NGE_ARCHIVE = "NGE_ARCHIVE",
  NGE_SUJETS = "NGE_SUJETS",
  NR_PERSONNALITES_ARCHIVES = "NR_PERSONNALITES_ARCHIVES",
  PECO_LIVRAISON = "PECO_LIVRAISON",
  PECO_SUJETS = "PECO_SUJETS",
  PECO_WEB = "PECO_WEB",
  PFEM_LIVRAISON = "PFEM_LIVRAISON",
  PFEM_SUJETS = "PFEM_SUJETS",
  PGAL_SUJETS = "PGAL_SUJETS",
  PGEO_SUJETS = "PGEO_SUJETS",
  PTVS_ARCHIVES_TV = "PTVS_ARCHIVES_TV",
  PTVS_LIVRAISON = "PTVS_LIVRAISON",
  PTVS_SUJETS = "PTVS_SUJETS",
  TEST_UNIT = "TEST_UNIT",
  TRV_CUI = "TRV_CUI",
  TRV_PHOTOS = "TRV_PHOTOS",
  VOICI_LIVRAISON = "VOICI_LIVRAISON",
  VOICI_SUJETS = "VOICI_SUJETS",
  VOI_ARCHIVES = "VOI_ARCHIVES",
  VOI_BASE_PEOPLE = "VOI_BASE_PEOPLE",
  VOI_BEAUTE = "VOI_BEAUTE",
  VOI_MODE = "VOI_MODE",
  VOI_SCOOP = "VOI_SCOOP",
}

export enum ArchiveType {
  ARCHIVE = "ARCHIVE",
  DELIVERY = "DELIVERY",
  NEWS = "NEWS",
  SUJET = "SUJET",
}

export enum ImportQueueStatusType {
  DELETED = "DELETED",
  FAILED = "FAILED",
  FINISHED = "FINISHED",
  PENDING = "PENDING",
}

export enum MetadataNameEnumType {
  AccessRights = "AccessRights",
  AddlModelInfo = "AddlModelInfo",
  Archive_child = "Archive_child",
  Archive_parent = "Archive_parent",
  AssetState = "AssetState",
  Audience = "Audience",
  AuthorsPosition = "AuthorsPosition",
  BackupName = "BackupName",
  BitmapGrayscalePicture = "BitmapGrayscalePicture",
  Brand = "Brand",
  BrandPrisma = "BrandPrisma",
  BrandShortName = "BrandShortName",
  CaptionWriter = "CaptionWriter",
  Category = "Category",
  CategoryPrisma = "CategoryPrisma",
  Certificate = "Certificate",
  CiAdrCity = "CiAdrCity",
  CiAdrCtry = "CiAdrCtry",
  CiAdrExtadr = "CiAdrExtadr",
  CiAdrPcode = "CiAdrPcode",
  CiAdrRegion = "CiAdrRegion",
  CiEmailWork = "CiEmailWork",
  CiTelWork = "CiTelWork",
  CiUrlWork = "CiUrlWork",
  City = "City",
  Classify = "Classify",
  Company = "Company",
  CompanyShortName = "CompanyShortName",
  Confidentiality = "Confidentiality",
  ContainedIn = "ContainedIn",
  ContentMediaKind = "ContentMediaKind",
  ContentValue = "ContentValue",
  CopyrightLayer = "CopyrightLayer",
  Country = "Country",
  CountryCode = "CountryCode",
  CreatedTime = "CreatedTime",
  CreatorTool = "CreatorTool",
  Credit = "Credit",
  CustomField14 = "CustomField14",
  CustomField15 = "CustomField15",
  CustomField16 = "CustomField16",
  CustomField17 = "CustomField17",
  CustomField20 = "CustomField20",
  CustomField5 = "CustomField5",
  CustomField6 = "CustomField6",
  CustomField7 = "CustomField7",
  CustomField9 = "CustomField9",
  DateCreated = "DateCreated",
  DateTimeDigitized = "DateTimeDigitized",
  DateTimeOriginal = "DateTimeOriginal",
  DeliveryAccount = "DeliveryAccount",
  DeliveryCompany = "DeliveryCompany",
  DeliveryCopyright = "DeliveryCopyright",
  DeliveryDateFolder = "DeliveryDateFolder",
  DeliveryDateTime = "DeliveryDateTime",
  DeliveryDcCreator = "DeliveryDcCreator",
  DeliveryDcRights = "DeliveryDcRights",
  DeliveryFileType = "DeliveryFileType",
  DeliveryFolder = "DeliveryFolder",
  DeliveryKind = "DeliveryKind",
  DeliveryPath = "DeliveryPath",
  DeliveryPersonShownintheImage = "DeliveryPersonShownintheImage",
  DeliveryPhotoshopCredit = "DeliveryPhotoshopCredit",
  DeliveryPhotoshopSource = "DeliveryPhotoshopSource",
  DeliveryService = "DeliveryService",
  DeliverySubject = "DeliverySubject",
  DeliveryUnderSubject = "DeliveryUnderSubject",
  Department = "Department",
  DigitalAssetURL = "DigitalAssetURL",
  Division = "Division",
  DocumentText = "DocumentText",
  EditStatus = "EditStatus",
  Edition = "Edition",
  EditorialVersion = "EditorialVersion",
  EnvironnementPhoto = "EnvironnementPhoto",
  EquipmentInstitution = "EquipmentInstitution",
  EquipmentManufacturer = "EquipmentManufacturer",
  Event = "Event",
  Exif = "Exif",
  ExifImageHeight = "ExifImageHeight",
  ExifImageWidth = "ExifImageWidth",
  FabStorage = "FabStorage",
  FileCheckFor = "FileCheckFor",
  FileInfoBitsPerPixel = "FileInfoBitsPerPixel",
  FileInfoFrames = "FileInfoFrames",
  FileInfoImageHeight = "FileInfoImageHeight",
  FileInfoImageWidth = "FileInfoImageWidth",
  FileInfoPhotometricInterpretation = "FileInfoPhotometricInterpretation",
  FileInfoTransferSyntax = "FileInfoTransferSyntax",
  FileStage = "FileStage",
  FileStatus = "FileStatus",
  FileType = "FileType",
  FixtureIdentifier = "FixtureIdentifier",
  Format = "Format",
  GPSLatitude = "GPSLatitude",
  GPSLongitude = "GPSLongitude",
  GPSProcessingMethod = "GPSProcessingMethod",
  Header = "Header",
  HeaderPrisma = "HeaderPrisma",
  Headline = "Headline",
  History = "History",
  ICCProfile = "ICCProfile",
  ID_subject = "ID_subject",
  ISOSpeedRatings = "ISOSpeedRatings",
  IdAssignment = "IdAssignment",
  IdMediaContent = "IdMediaContent",
  IdPhotoPrisma = "IdPhotoPrisma",
  ImageNotes = "ImageNotes",
  ImageUniqueID = "ImageUniqueID",
  Instructions = "Instructions",
  IntellectualGenre = "IntellectualGenre",
  Issue = "Issue",
  JobId = "JobId",
  JobProcessing = "JobProcessing",
  LayoutPictureEditing = "LayoutPictureEditing",
  LayoutStorage = "LayoutStorage",
  Links = "Links",
  LocalCaption = "LocalCaption",
  Location = "Location",
  Make = "Make",
  Manifest = "Manifest",
  Marked = "Marked",
  MasterDocumentId = "MasterDocumentId",
  MaxAvailHeight = "MaxAvailHeight",
  MaxAvailWidth = "MaxAvailWidth",
  MinorModelAgeDisclosure = "MinorModelAgeDisclosure",
  Model = "Model",
  ModelAge = "ModelAge",
  ModelReleaseID = "ModelReleaseID",
  ModelReleaseStatus = "ModelReleaseStatus",
  ObjectCycle = "ObjectCycle",
  OrganisationInImageName = "OrganisationInImageName",
  OriginalColor = "OriginalColor",
  OriginalICCProfile = "OriginalICCProfile",
  OriginalName = "OriginalName",
  OriginalWeigth = "OriginalWeigth",
  Owner = "Owner",
  OwnerId = "OwnerId",
  Page = "Page",
  PagePrisma = "PagePrisma",
  PaintBasedCorrections = "PaintBasedCorrections",
  PatientDOB = "PatientDOB",
  PatientID = "PatientID",
  PatientName = "PatientName",
  PatientSex = "PatientSex",
  PersonInImage = "PersonInImage",
  PhotoStorage = "PhotoStorage",
  PrepressPictureEditing = "PrepressPictureEditing",
  PriceLevel = "PriceLevel",
  PrintingProfile = "PrintingProfile",
  PrismaProduction = "PrismaProduction",
  ProcessHistory = "ProcessHistory",
  ProcessParameter = "ProcessParameter",
  ProcessStatus = "ProcessStatus",
  Product = "Product",
  ProductShortName = "ProductShortName",
  Products = "Products",
  Produits = "Produits",
  ProgramVersion = "ProgramVersion",
  PropertyReleaseID = "PropertyReleaseID",
  PropertyReleaseStatus = "PropertyReleaseStatus",
  Publisher = "Publisher",
  QualifiedUsePrismaBy = "QualifiedUsePrismaBy",
  QualifiedUsePrismaDate = "QualifiedUsePrismaDate",
  QualifiedUsePrismaDuration = "QualifiedUsePrismaDuration",
  QualifiedUsePrismaSupport = "QualifiedUsePrismaSupport",
  Rating = "Rating",
  ReferenceDate = "ReferenceDate",
  ReferenceNumber = "ReferenceNumber",
  ReferenceService = "ReferenceService",
  ReleaseDate = "ReleaseDate",
  ReleaseTime = "ReleaseTime",
  RequiredPermission = "RequiredPermission",
  ResolutionKind = "ResolutionKind",
  Royaltyfree = "Royaltyfree",
  Scene = "Scene",
  Section = "Section",
  SentTo = "SentTo",
  SerialNumber = "SerialNumber",
  SeriesDateTime = "SeriesDateTime",
  SeriesDescription = "SeriesDescription",
  SeriesModality = "SeriesModality",
  SeriesNumber = "SeriesNumber",
  ShortUniqueId = "ShortUniqueId",
  Source = "Source",
  State = "State",
  StudyDateTime = "StudyDateTime",
  StudyDescription = "StudyDescription",
  StudyID = "StudyID",
  StudyPhysician = "StudyPhysician",
  SubjectCode = "SubjectCode",
  SubjectPrisma = "SubjectPrisma",
  SupplementalCategories = "SupplementalCategories",
  TargetVersion = "TargetVersion",
  ToneCurve = "ToneCurve",
  TransferredBy = "TransferredBy",
  TransferredByEmail = "TransferredByEmail",
  TransferredByFullName = "TransferredByFullName",
  TransmissionReference = "TransmissionReference",
  Type = "Type",
  UnderUnderSubject = "UnderUnderSubject",
  Undersubject = "Undersubject",
  UniqueId = "UniqueId",
  Unit = "Unit",
  UnitShortName = "UnitShortName",
  UploadTime = "UploadTime",
  UploadedBy = "UploadedBy",
  UploadedByFullName = "UploadedByFullName",
  Urgency = "Urgency",
  UsageTerms = "UsageTerms",
  UserComment = "UserComment",
  UserDefined195 = "UserDefined195",
  UserDefined237 = "UserDefined237",
  UserDefined238 = "UserDefined238",
  UserDefined239 = "UserDefined239",
  UserDefined242 = "UserDefined242",
  UserDefined62 = "UserDefined62",
  Valid = "Valid",
  Version = "Version",
  WebStatement = "WebStatement",
  WorkflowKind = "WorkflowKind",
  XMPFileStamps = "XMPFileStamps",
  XMPHistory = "XMPHistory",
  attributionName = "attributionName",
  attributionURL = "attributionURL",
  creator = "creator",
  description = "description",
  filesize = "filesize",
  license = "license",
  morePermissions = "morePermissions",
  publishingIssue = "publishingIssue",
  publishingSubject = "publishingSubject",
  rights = "rights",
  subject = "subject",
  title = "title",
}

export enum MetadataValueTypeEnum {
  Date = "Date",
  List = "List",
  Text = "Text",
}

export enum PhotoOrderByInput {
  _id_ASC = "_id_ASC",
  _id_DESC = "_id_DESC",
  contentType_ASC = "contentType_ASC",
  contentType_DESC = "contentType_DESC",
  createdAt_ASC = "createdAt_ASC",
  createdAt_DESC = "createdAt_DESC",
  id_ASC = "id_ASC",
  id_DESC = "id_DESC",
  isLegacy_ASC = "isLegacy_ASC",
  isLegacy_DESC = "isLegacy_DESC",
  isUploaded_ASC = "isUploaded_ASC",
  isUploaded_DESC = "isUploaded_DESC",
  originalName_ASC = "originalName_ASC",
  originalName_DESC = "originalName_DESC",
  updatedAt_ASC = "updatedAt_ASC",
  updatedAt_DESC = "updatedAt_DESC",
}

/**
 * Filters the "Archive" nodes by specifying some conditions
 */
export interface ArchiveWhereInput {
  _id?: number | null;
  _id_not?: number | null;
  _id_in?: number[] | null;
  _id_not_in?: number[] | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  id?: string | null;
  id_not?: string | null;
  id_in?: string[] | null;
  id_not_in?: string[] | null;
  archiveId?: number | null;
  archiveId_not?: number | null;
  archiveId_is_null?: boolean | null;
  archiveId_in?: (number | null)[] | null;
  archiveId_not_in?: (number | null)[] | null;
  archiveId_lt?: number | null;
  archiveId_lte?: number | null;
  archiveId_gt?: number | null;
  archiveId_gte?: number | null;
  name?: ArchiveKeyType | null;
  name_not?: ArchiveKeyType | null;
  name_is_null?: boolean | null;
  name_in?: (ArchiveKeyType | null)[] | null;
  name_not_in?: (ArchiveKeyType | null)[] | null;
  label?: string | null;
  label_not?: string | null;
  label_is_null?: boolean | null;
  label_in?: (string | null)[] | null;
  label_not_in?: (string | null)[] | null;
  label_contains?: string | null;
  label_not_contains?: string | null;
  label_starts_with?: string | null;
  label_not_starts_with?: string | null;
  label_ends_with?: string | null;
  label_not_ends_with?: string | null;
  label_lt?: string | null;
  label_lte?: string | null;
  label_gt?: string | null;
  label_gte?: string | null;
  type?: ArchiveType | null;
  type_not?: ArchiveType | null;
  type_is_null?: boolean | null;
  type_in?: (ArchiveType | null)[] | null;
  type_not_in?: (ArchiveType | null)[] | null;
  hasCategories?: boolean | null;
  hasCategories_not?: boolean | null;
  hasCategories_is_null?: boolean | null;
  hasCategories_in?: (boolean | null)[] | null;
  hasCategories_not_in?: (boolean | null)[] | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  categories_some?: CategoryWhereInput | null;
  deliverySubjects_some?: DeliverySubjectWhereInput | null;
  gcImportSettings_some?: GcImportSettingWhereInput | null;
  importQueues_some?: ImportQueueWhereInput | null;
  photos_some?: PhotoWhereInput | null;
  photoMetadatas_some?: PhotoMetadataWhereInput | null;
  photoMetadatas8_some?: PhotoMetadata8WhereInput | null;
  photoMetadatas5059_some?: PhotoMetadata5059WhereInput | null;
  photoMetadatas5055_some?: PhotoMetadata5055WhereInput | null;
  photoMetadatas1_some?: PhotoMetadata1WhereInput | null;
  photoMetadatas5044_some?: PhotoMetadata5044WhereInput | null;
  photoMetadatas5020_some?: PhotoMetadata5020WhereInput | null;
  photoMetadatas5041_some?: PhotoMetadata5041WhereInput | null;
  photoMetadatas9_some?: PhotoMetadata9WhereInput | null;
  photoMetadatas5017_some?: PhotoMetadata5017WhereInput | null;
  photoMetadatas4_some?: PhotoMetadata4WhereInput | null;
  photoMetadatas5039_some?: PhotoMetadata5039WhereInput | null;
  photoMetadatas5025_some?: PhotoMetadata5025WhereInput | null;
  photoMetadatas5040_some?: PhotoMetadata5040WhereInput | null;
  photoMetadatas11_some?: PhotoMetadata11WhereInput | null;
  photoMetadatas6_some?: PhotoMetadata6WhereInput | null;
  photoMetadatas3_some?: PhotoMetadata3WhereInput | null;
  photoMetadatas2_some?: PhotoMetadata2WhereInput | null;
  photoMetadatas5019_some?: PhotoMetadata5019WhereInput | null;
  photoMetadatas5_some?: PhotoMetadata5WhereInput | null;
  photoMetadatas5033_some?: PhotoMetadata5033WhereInput | null;
  photoMetadatas5034_some?: PhotoMetadata5034WhereInput | null;
  photoMetadatas5012_some?: PhotoMetadata5012WhereInput | null;
  photoMetadatas5038_some?: PhotoMetadata5038WhereInput | null;
  photoMetadatas5036_some?: PhotoMetadata5036WhereInput | null;
  photoMetadatas5056_some?: PhotoMetadata5056WhereInput | null;
  photoMetadatas10_some?: PhotoMetadata10WhereInput | null;
  photoMetadatas5054_some?: PhotoMetadata5054WhereInput | null;
  photoMetadatas5052_some?: PhotoMetadata5052WhereInput | null;
  photoMetadatas5057_some?: PhotoMetadata5057WhereInput | null;
  photoMetadatas5032_some?: PhotoMetadata5032WhereInput | null;
  photoMetadatas5053_some?: PhotoMetadata5053WhereInput | null;
  photoMetadatas5043_some?: PhotoMetadata5043WhereInput | null;
  photoMetadatas7_some?: PhotoMetadata7WhereInput | null;
  photoMetadatas5048_some?: PhotoMetadata5048WhereInput | null;
  photoMetadatas5001_some?: PhotoMetadata5001WhereInput | null;
  photoMetadatas5060_some?: PhotoMetadata5060WhereInput | null;
  photoMetadatas5037_some?: PhotoMetadata5037WhereInput | null;
  photoMetadatas5051_some?: PhotoMetadata5051WhereInput | null;
  photoMetadatas5050_some?: PhotoMetadata5050WhereInput | null;
  AND?: ArchiveWhereInput[] | null;
  OR?: ArchiveWhereInput[] | null;
  NOT?: ArchiveWhereInput | null;
}

/**
 * Filters the "Category" nodes by specifying some conditions
 */
export interface CategoryWhereInput {
  _id?: number | null;
  _id_not?: number | null;
  _id_in?: number[] | null;
  _id_not_in?: number[] | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  id?: string | null;
  id_not?: string | null;
  id_in?: string[] | null;
  id_not_in?: string[] | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  label?: string | null;
  label_not?: string | null;
  label_is_null?: boolean | null;
  label_in?: (string | null)[] | null;
  label_not_in?: (string | null)[] | null;
  label_contains?: string | null;
  label_not_contains?: string | null;
  label_starts_with?: string | null;
  label_not_starts_with?: string | null;
  label_ends_with?: string | null;
  label_not_ends_with?: string | null;
  label_lt?: string | null;
  label_lte?: string | null;
  label_gt?: string | null;
  label_gte?: string | null;
  archive?: ArchiveWhereInput | null;
  parent?: CategoryWhereInput | null;
  parent_is_null?: boolean | null;
  children_some?: CategoryWhereInput | null;
  photos_some?: PhotoWhereInput | null;
  AND?: CategoryWhereInput[] | null;
  OR?: CategoryWhereInput[] | null;
  NOT?: CategoryWhereInput | null;
}

/**
 * Filters the "DeliverySubject" nodes by specifying some conditions
 */
export interface DeliverySubjectWhereInput {
  _id?: number | null;
  _id_not?: number | null;
  _id_in?: number[] | null;
  _id_not_in?: number[] | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  name?: string | null;
  name_not?: string | null;
  name_in?: string[] | null;
  name_not_in?: string[] | null;
  name_contains?: string | null;
  name_not_contains?: string | null;
  name_starts_with?: string | null;
  name_not_starts_with?: string | null;
  name_ends_with?: string | null;
  name_not_ends_with?: string | null;
  name_lt?: string | null;
  name_lte?: string | null;
  name_gt?: string | null;
  name_gte?: string | null;
  agency?: string | null;
  agency_not?: string | null;
  agency_in?: string[] | null;
  agency_not_in?: string[] | null;
  agency_contains?: string | null;
  agency_not_contains?: string | null;
  agency_starts_with?: string | null;
  agency_not_starts_with?: string | null;
  agency_ends_with?: string | null;
  agency_not_ends_with?: string | null;
  agency_lt?: string | null;
  agency_lte?: string | null;
  agency_gt?: string | null;
  agency_gte?: string | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  archive?: ArchiveWhereInput | null;
  AND?: DeliverySubjectWhereInput[] | null;
  OR?: DeliverySubjectWhereInput[] | null;
  NOT?: DeliverySubjectWhereInput | null;
}

/**
 * Filters the "GcImportSetting" nodes by specifying some conditions
 */
export interface GcImportSettingWhereInput {
  _id?: number | null;
  _id_not?: number | null;
  _id_in?: number[] | null;
  _id_not_in?: number[] | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  id?: string | null;
  id_not?: string | null;
  id_in?: string[] | null;
  id_not_in?: string[] | null;
  period?: number | null;
  period_not?: number | null;
  period_is_null?: boolean | null;
  period_in?: (number | null)[] | null;
  period_not_in?: (number | null)[] | null;
  period_lt?: number | null;
  period_lte?: number | null;
  period_gt?: number | null;
  period_gte?: number | null;
  enabled?: boolean | null;
  enabled_not?: boolean | null;
  enabled_is_null?: boolean | null;
  enabled_in?: (boolean | null)[] | null;
  enabled_not_in?: (boolean | null)[] | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  archive?: ArchiveWhereInput | null;
  AND?: GcImportSettingWhereInput[] | null;
  OR?: GcImportSettingWhereInput[] | null;
  NOT?: GcImportSettingWhereInput | null;
}

/**
 * Filters the "ImportQueue" nodes by specifying some conditions
 */
export interface ImportQueueWhereInput {
  _id?: number | null;
  _id_not?: number | null;
  _id_in?: number[] | null;
  _id_not_in?: number[] | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  message?: string | null;
  message_not?: string | null;
  message_is_null?: boolean | null;
  message_in?: (string | null)[] | null;
  message_not_in?: (string | null)[] | null;
  message_contains?: string | null;
  message_not_contains?: string | null;
  message_starts_with?: string | null;
  message_not_starts_with?: string | null;
  message_ends_with?: string | null;
  message_not_ends_with?: string | null;
  message_lt?: string | null;
  message_lte?: string | null;
  message_gt?: string | null;
  message_gte?: string | null;
  s3key?: string | null;
  s3key_not?: string | null;
  s3key_in?: string[] | null;
  s3key_not_in?: string[] | null;
  s3key_contains?: string | null;
  s3key_not_contains?: string | null;
  s3key_starts_with?: string | null;
  s3key_not_starts_with?: string | null;
  s3key_ends_with?: string | null;
  s3key_not_ends_with?: string | null;
  s3key_lt?: string | null;
  s3key_lte?: string | null;
  s3key_gt?: string | null;
  s3key_gte?: string | null;
  filename?: string | null;
  filename_not?: string | null;
  filename_in?: string[] | null;
  filename_not_in?: string[] | null;
  filename_contains?: string | null;
  filename_not_contains?: string | null;
  filename_starts_with?: string | null;
  filename_not_starts_with?: string | null;
  filename_ends_with?: string | null;
  filename_not_ends_with?: string | null;
  filename_lt?: string | null;
  filename_lte?: string | null;
  filename_gt?: string | null;
  filename_gte?: string | null;
  agency?: string | null;
  agency_not?: string | null;
  agency_is_null?: boolean | null;
  agency_in?: (string | null)[] | null;
  agency_not_in?: (string | null)[] | null;
  agency_contains?: string | null;
  agency_not_contains?: string | null;
  agency_starts_with?: string | null;
  agency_not_starts_with?: string | null;
  agency_ends_with?: string | null;
  agency_not_ends_with?: string | null;
  agency_lt?: string | null;
  agency_lte?: string | null;
  agency_gt?: string | null;
  agency_gte?: string | null;
  subject?: string | null;
  subject_not?: string | null;
  subject_is_null?: boolean | null;
  subject_in?: (string | null)[] | null;
  subject_not_in?: (string | null)[] | null;
  subject_contains?: string | null;
  subject_not_contains?: string | null;
  subject_starts_with?: string | null;
  subject_not_starts_with?: string | null;
  subject_ends_with?: string | null;
  subject_not_ends_with?: string | null;
  subject_lt?: string | null;
  subject_lte?: string | null;
  subject_gt?: string | null;
  subject_gte?: string | null;
  type?: string | null;
  type_not?: string | null;
  type_is_null?: boolean | null;
  type_in?: (string | null)[] | null;
  type_not_in?: (string | null)[] | null;
  type_contains?: string | null;
  type_not_contains?: string | null;
  type_starts_with?: string | null;
  type_not_starts_with?: string | null;
  type_ends_with?: string | null;
  type_not_ends_with?: string | null;
  type_lt?: string | null;
  type_lte?: string | null;
  type_gt?: string | null;
  type_gte?: string | null;
  size?: number | null;
  size_not?: number | null;
  size_is_null?: boolean | null;
  size_in?: (number | null)[] | null;
  size_not_in?: (number | null)[] | null;
  size_lt?: number | null;
  size_lte?: number | null;
  size_gt?: number | null;
  size_gte?: number | null;
  retry?: number | null;
  retry_not?: number | null;
  retry_is_null?: boolean | null;
  retry_in?: (number | null)[] | null;
  retry_not_in?: (number | null)[] | null;
  retry_lt?: number | null;
  retry_lte?: number | null;
  retry_gt?: number | null;
  retry_gte?: number | null;
  duration?: number | null;
  duration_not?: number | null;
  duration_is_null?: boolean | null;
  duration_in?: (number | null)[] | null;
  duration_not_in?: (number | null)[] | null;
  duration_lt?: number | null;
  duration_lte?: number | null;
  duration_gt?: number | null;
  duration_gte?: number | null;
  status?: ImportQueueStatusType | null;
  status_not?: ImportQueueStatusType | null;
  status_in?: ImportQueueStatusType[] | null;
  status_not_in?: ImportQueueStatusType[] | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  importedAt?: GraphQL$DateTime | null;
  importedAt_not?: GraphQL$DateTime | null;
  importedAt_is_null?: boolean | null;
  importedAt_in?: (GraphQL$DateTime | null)[] | null;
  importedAt_not_in?: (GraphQL$DateTime | null)[] | null;
  importedAt_lt?: GraphQL$DateTime | null;
  importedAt_lte?: GraphQL$DateTime | null;
  importedAt_gt?: GraphQL$DateTime | null;
  importedAt_gte?: GraphQL$DateTime | null;
  archive?: ArchiveWhereInput | null;
  archive_is_null?: boolean | null;
  AND?: ImportQueueWhereInput[] | null;
  OR?: ImportQueueWhereInput[] | null;
  NOT?: ImportQueueWhereInput | null;
}

/**
 * Filters the "Metadata" nodes by specifying some conditions
 */
export interface MetadataWhereInput {
  _id?: number | null;
  _id_not?: number | null;
  _id_in?: number[] | null;
  _id_not_in?: number[] | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  id?: string | null;
  id_not?: string | null;
  id_in?: string[] | null;
  id_not_in?: string[] | null;
  name?: MetadataNameEnumType | null;
  name_not?: MetadataNameEnumType | null;
  name_in?: MetadataNameEnumType[] | null;
  name_not_in?: MetadataNameEnumType[] | null;
  legacyName?: string | null;
  legacyName_not?: string | null;
  legacyName_is_null?: boolean | null;
  legacyName_in?: (string | null)[] | null;
  legacyName_not_in?: (string | null)[] | null;
  legacyName_contains?: string | null;
  legacyName_not_contains?: string | null;
  legacyName_starts_with?: string | null;
  legacyName_not_starts_with?: string | null;
  legacyName_ends_with?: string | null;
  legacyName_not_ends_with?: string | null;
  legacyName_lt?: string | null;
  legacyName_lte?: string | null;
  legacyName_gt?: string | null;
  legacyName_gte?: string | null;
  label?: string | null;
  label_not?: string | null;
  label_in?: string[] | null;
  label_not_in?: string[] | null;
  label_contains?: string | null;
  label_not_contains?: string | null;
  label_starts_with?: string | null;
  label_not_starts_with?: string | null;
  label_ends_with?: string | null;
  label_not_ends_with?: string | null;
  label_lt?: string | null;
  label_lte?: string | null;
  label_gt?: string | null;
  label_gte?: string | null;
  namespace?: string | null;
  namespace_not?: string | null;
  namespace_in?: string[] | null;
  namespace_not_in?: string[] | null;
  namespace_contains?: string | null;
  namespace_not_contains?: string | null;
  namespace_starts_with?: string | null;
  namespace_not_starts_with?: string | null;
  namespace_ends_with?: string | null;
  namespace_not_ends_with?: string | null;
  namespace_lt?: string | null;
  namespace_lte?: string | null;
  namespace_gt?: string | null;
  namespace_gte?: string | null;
  structName?: string | null;
  structName_not?: string | null;
  structName_is_null?: boolean | null;
  structName_in?: (string | null)[] | null;
  structName_not_in?: (string | null)[] | null;
  structName_contains?: string | null;
  structName_not_contains?: string | null;
  structName_starts_with?: string | null;
  structName_not_starts_with?: string | null;
  structName_ends_with?: string | null;
  structName_not_ends_with?: string | null;
  structName_lt?: string | null;
  structName_lte?: string | null;
  structName_gt?: string | null;
  structName_gte?: string | null;
  type?: MetadataValueTypeEnum | null;
  type_not?: MetadataValueTypeEnum | null;
  type_in?: MetadataValueTypeEnum[] | null;
  type_not_in?: MetadataValueTypeEnum[] | null;
  photoMetadatas_some?: PhotoMetadataWhereInput | null;
  photoMetadatas8_some?: PhotoMetadata8WhereInput | null;
  photoMetadatas5059_some?: PhotoMetadata5059WhereInput | null;
  photoMetadatas5055_some?: PhotoMetadata5055WhereInput | null;
  photoMetadatas1_some?: PhotoMetadata1WhereInput | null;
  photoMetadatas5044_some?: PhotoMetadata5044WhereInput | null;
  photoMetadatas5020_some?: PhotoMetadata5020WhereInput | null;
  photoMetadatas5041_some?: PhotoMetadata5041WhereInput | null;
  photoMetadatas9_some?: PhotoMetadata9WhereInput | null;
  photoMetadatas5017_some?: PhotoMetadata5017WhereInput | null;
  photoMetadatas4_some?: PhotoMetadata4WhereInput | null;
  photoMetadatas5039_some?: PhotoMetadata5039WhereInput | null;
  photoMetadatas5025_some?: PhotoMetadata5025WhereInput | null;
  photoMetadatas5040_some?: PhotoMetadata5040WhereInput | null;
  photoMetadatas11_some?: PhotoMetadata11WhereInput | null;
  photoMetadatas6_some?: PhotoMetadata6WhereInput | null;
  photoMetadatas3_some?: PhotoMetadata3WhereInput | null;
  photoMetadatas2_some?: PhotoMetadata2WhereInput | null;
  photoMetadatas5019_some?: PhotoMetadata5019WhereInput | null;
  photoMetadatas5_some?: PhotoMetadata5WhereInput | null;
  photoMetadatas5033_some?: PhotoMetadata5033WhereInput | null;
  photoMetadatas5034_some?: PhotoMetadata5034WhereInput | null;
  photoMetadatas5012_some?: PhotoMetadata5012WhereInput | null;
  photoMetadatas5038_some?: PhotoMetadata5038WhereInput | null;
  photoMetadatas5036_some?: PhotoMetadata5036WhereInput | null;
  photoMetadatas5056_some?: PhotoMetadata5056WhereInput | null;
  photoMetadatas10_some?: PhotoMetadata10WhereInput | null;
  photoMetadatas5054_some?: PhotoMetadata5054WhereInput | null;
  photoMetadatas5052_some?: PhotoMetadata5052WhereInput | null;
  photoMetadatas5057_some?: PhotoMetadata5057WhereInput | null;
  photoMetadatas5032_some?: PhotoMetadata5032WhereInput | null;
  photoMetadatas5053_some?: PhotoMetadata5053WhereInput | null;
  photoMetadatas5043_some?: PhotoMetadata5043WhereInput | null;
  photoMetadatas7_some?: PhotoMetadata7WhereInput | null;
  photoMetadatas5048_some?: PhotoMetadata5048WhereInput | null;
  photoMetadatas5001_some?: PhotoMetadata5001WhereInput | null;
  photoMetadatas5060_some?: PhotoMetadata5060WhereInput | null;
  photoMetadatas5037_some?: PhotoMetadata5037WhereInput | null;
  photoMetadatas5051_some?: PhotoMetadata5051WhereInput | null;
  photoMetadatas5050_some?: PhotoMetadata5050WhereInput | null;
  AND?: MetadataWhereInput[] | null;
  OR?: MetadataWhereInput[] | null;
  NOT?: MetadataWhereInput | null;
}

/**
 * Filters the "PhotoMetadata10" nodes by specifying some conditions
 */
export interface PhotoMetadata10WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata10WhereInput[] | null;
  OR?: PhotoMetadata10WhereInput[] | null;
  NOT?: PhotoMetadata10WhereInput | null;
}

/**
 * Filters the "PhotoMetadata11" nodes by specifying some conditions
 */
export interface PhotoMetadata11WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata11WhereInput[] | null;
  OR?: PhotoMetadata11WhereInput[] | null;
  NOT?: PhotoMetadata11WhereInput | null;
}

/**
 * Filters the "PhotoMetadata1" nodes by specifying some conditions
 */
export interface PhotoMetadata1WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata1WhereInput[] | null;
  OR?: PhotoMetadata1WhereInput[] | null;
  NOT?: PhotoMetadata1WhereInput | null;
}

/**
 * Filters the "PhotoMetadata2" nodes by specifying some conditions
 */
export interface PhotoMetadata2WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata2WhereInput[] | null;
  OR?: PhotoMetadata2WhereInput[] | null;
  NOT?: PhotoMetadata2WhereInput | null;
}

/**
 * Filters the "PhotoMetadata3" nodes by specifying some conditions
 */
export interface PhotoMetadata3WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata3WhereInput[] | null;
  OR?: PhotoMetadata3WhereInput[] | null;
  NOT?: PhotoMetadata3WhereInput | null;
}

/**
 * Filters the "PhotoMetadata4" nodes by specifying some conditions
 */
export interface PhotoMetadata4WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata4WhereInput[] | null;
  OR?: PhotoMetadata4WhereInput[] | null;
  NOT?: PhotoMetadata4WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5001" nodes by specifying some conditions
 */
export interface PhotoMetadata5001WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5001WhereInput[] | null;
  OR?: PhotoMetadata5001WhereInput[] | null;
  NOT?: PhotoMetadata5001WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5012" nodes by specifying some conditions
 */
export interface PhotoMetadata5012WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5012WhereInput[] | null;
  OR?: PhotoMetadata5012WhereInput[] | null;
  NOT?: PhotoMetadata5012WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5017" nodes by specifying some conditions
 */
export interface PhotoMetadata5017WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5017WhereInput[] | null;
  OR?: PhotoMetadata5017WhereInput[] | null;
  NOT?: PhotoMetadata5017WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5019" nodes by specifying some conditions
 */
export interface PhotoMetadata5019WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5019WhereInput[] | null;
  OR?: PhotoMetadata5019WhereInput[] | null;
  NOT?: PhotoMetadata5019WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5020" nodes by specifying some conditions
 */
export interface PhotoMetadata5020WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5020WhereInput[] | null;
  OR?: PhotoMetadata5020WhereInput[] | null;
  NOT?: PhotoMetadata5020WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5025" nodes by specifying some conditions
 */
export interface PhotoMetadata5025WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5025WhereInput[] | null;
  OR?: PhotoMetadata5025WhereInput[] | null;
  NOT?: PhotoMetadata5025WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5032" nodes by specifying some conditions
 */
export interface PhotoMetadata5032WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5032WhereInput[] | null;
  OR?: PhotoMetadata5032WhereInput[] | null;
  NOT?: PhotoMetadata5032WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5033" nodes by specifying some conditions
 */
export interface PhotoMetadata5033WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5033WhereInput[] | null;
  OR?: PhotoMetadata5033WhereInput[] | null;
  NOT?: PhotoMetadata5033WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5034" nodes by specifying some conditions
 */
export interface PhotoMetadata5034WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5034WhereInput[] | null;
  OR?: PhotoMetadata5034WhereInput[] | null;
  NOT?: PhotoMetadata5034WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5036" nodes by specifying some conditions
 */
export interface PhotoMetadata5036WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5036WhereInput[] | null;
  OR?: PhotoMetadata5036WhereInput[] | null;
  NOT?: PhotoMetadata5036WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5037" nodes by specifying some conditions
 */
export interface PhotoMetadata5037WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5037WhereInput[] | null;
  OR?: PhotoMetadata5037WhereInput[] | null;
  NOT?: PhotoMetadata5037WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5038" nodes by specifying some conditions
 */
export interface PhotoMetadata5038WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5038WhereInput[] | null;
  OR?: PhotoMetadata5038WhereInput[] | null;
  NOT?: PhotoMetadata5038WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5039" nodes by specifying some conditions
 */
export interface PhotoMetadata5039WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5039WhereInput[] | null;
  OR?: PhotoMetadata5039WhereInput[] | null;
  NOT?: PhotoMetadata5039WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5040" nodes by specifying some conditions
 */
export interface PhotoMetadata5040WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5040WhereInput[] | null;
  OR?: PhotoMetadata5040WhereInput[] | null;
  NOT?: PhotoMetadata5040WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5041" nodes by specifying some conditions
 */
export interface PhotoMetadata5041WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5041WhereInput[] | null;
  OR?: PhotoMetadata5041WhereInput[] | null;
  NOT?: PhotoMetadata5041WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5043" nodes by specifying some conditions
 */
export interface PhotoMetadata5043WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5043WhereInput[] | null;
  OR?: PhotoMetadata5043WhereInput[] | null;
  NOT?: PhotoMetadata5043WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5044" nodes by specifying some conditions
 */
export interface PhotoMetadata5044WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5044WhereInput[] | null;
  OR?: PhotoMetadata5044WhereInput[] | null;
  NOT?: PhotoMetadata5044WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5048" nodes by specifying some conditions
 */
export interface PhotoMetadata5048WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5048WhereInput[] | null;
  OR?: PhotoMetadata5048WhereInput[] | null;
  NOT?: PhotoMetadata5048WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5050" nodes by specifying some conditions
 */
export interface PhotoMetadata5050WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5050WhereInput[] | null;
  OR?: PhotoMetadata5050WhereInput[] | null;
  NOT?: PhotoMetadata5050WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5051" nodes by specifying some conditions
 */
export interface PhotoMetadata5051WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5051WhereInput[] | null;
  OR?: PhotoMetadata5051WhereInput[] | null;
  NOT?: PhotoMetadata5051WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5052" nodes by specifying some conditions
 */
export interface PhotoMetadata5052WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5052WhereInput[] | null;
  OR?: PhotoMetadata5052WhereInput[] | null;
  NOT?: PhotoMetadata5052WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5053" nodes by specifying some conditions
 */
export interface PhotoMetadata5053WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5053WhereInput[] | null;
  OR?: PhotoMetadata5053WhereInput[] | null;
  NOT?: PhotoMetadata5053WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5054" nodes by specifying some conditions
 */
export interface PhotoMetadata5054WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5054WhereInput[] | null;
  OR?: PhotoMetadata5054WhereInput[] | null;
  NOT?: PhotoMetadata5054WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5055" nodes by specifying some conditions
 */
export interface PhotoMetadata5055WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5055WhereInput[] | null;
  OR?: PhotoMetadata5055WhereInput[] | null;
  NOT?: PhotoMetadata5055WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5056" nodes by specifying some conditions
 */
export interface PhotoMetadata5056WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5056WhereInput[] | null;
  OR?: PhotoMetadata5056WhereInput[] | null;
  NOT?: PhotoMetadata5056WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5057" nodes by specifying some conditions
 */
export interface PhotoMetadata5057WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5057WhereInput[] | null;
  OR?: PhotoMetadata5057WhereInput[] | null;
  NOT?: PhotoMetadata5057WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5059" nodes by specifying some conditions
 */
export interface PhotoMetadata5059WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5059WhereInput[] | null;
  OR?: PhotoMetadata5059WhereInput[] | null;
  NOT?: PhotoMetadata5059WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5060" nodes by specifying some conditions
 */
export interface PhotoMetadata5060WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5060WhereInput[] | null;
  OR?: PhotoMetadata5060WhereInput[] | null;
  NOT?: PhotoMetadata5060WhereInput | null;
}

/**
 * Filters the "PhotoMetadata5" nodes by specifying some conditions
 */
export interface PhotoMetadata5WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata5WhereInput[] | null;
  OR?: PhotoMetadata5WhereInput[] | null;
  NOT?: PhotoMetadata5WhereInput | null;
}

/**
 * Filters the "PhotoMetadata6" nodes by specifying some conditions
 */
export interface PhotoMetadata6WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata6WhereInput[] | null;
  OR?: PhotoMetadata6WhereInput[] | null;
  NOT?: PhotoMetadata6WhereInput | null;
}

/**
 * Filters the "PhotoMetadata7" nodes by specifying some conditions
 */
export interface PhotoMetadata7WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata7WhereInput[] | null;
  OR?: PhotoMetadata7WhereInput[] | null;
  NOT?: PhotoMetadata7WhereInput | null;
}

/**
 * Filters the "PhotoMetadata8" nodes by specifying some conditions
 */
export interface PhotoMetadata8WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata8WhereInput[] | null;
  OR?: PhotoMetadata8WhereInput[] | null;
  NOT?: PhotoMetadata8WhereInput | null;
}

/**
 * Filters the "PhotoMetadata9" nodes by specifying some conditions
 */
export interface PhotoMetadata9WhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadata9WhereInput[] | null;
  OR?: PhotoMetadata9WhereInput[] | null;
  NOT?: PhotoMetadata9WhereInput | null;
}

/**
 * Filters the "PhotoMetadata" nodes by specifying some conditions
 */
export interface PhotoMetadataWhereInput {
  id?: number | null;
  id_not?: number | null;
  id_in?: number[] | null;
  id_not_in?: number[] | null;
  id_lt?: number | null;
  id_lte?: number | null;
  id_gt?: number | null;
  id_gte?: number | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  value?: string | null;
  value_not?: string | null;
  value_is_null?: boolean | null;
  value_in?: (string | null)[] | null;
  value_not_in?: (string | null)[] | null;
  value_contains?: string | null;
  value_not_contains?: string | null;
  value_starts_with?: string | null;
  value_not_starts_with?: string | null;
  value_ends_with?: string | null;
  value_not_ends_with?: string | null;
  value_lt?: string | null;
  value_lte?: string | null;
  value_gt?: string | null;
  value_gte?: string | null;
  photo?: PhotoWhereInput | null;
  metadata?: MetadataWhereInput | null;
  archive?: ArchiveWhereInput | null;
  AND?: PhotoMetadataWhereInput[] | null;
  OR?: PhotoMetadataWhereInput[] | null;
  NOT?: PhotoMetadataWhereInput | null;
}

/**
 * Filters the "Photo" nodes by specifying some conditions
 */
export interface PhotoWhereInput {
  _id?: number | null;
  _id_not?: number | null;
  _id_in?: number[] | null;
  _id_not_in?: number[] | null;
  _id_lt?: number | null;
  _id_lte?: number | null;
  _id_gt?: number | null;
  _id_gte?: number | null;
  id?: string | null;
  id_not?: string | null;
  id_in?: string[] | null;
  id_not_in?: string[] | null;
  originalName?: string | null;
  originalName_not?: string | null;
  originalName_is_null?: boolean | null;
  originalName_in?: (string | null)[] | null;
  originalName_not_in?: (string | null)[] | null;
  originalName_contains?: string | null;
  originalName_not_contains?: string | null;
  originalName_starts_with?: string | null;
  originalName_not_starts_with?: string | null;
  originalName_ends_with?: string | null;
  originalName_not_ends_with?: string | null;
  originalName_lt?: string | null;
  originalName_lte?: string | null;
  originalName_gt?: string | null;
  originalName_gte?: string | null;
  contentType?: string | null;
  contentType_not?: string | null;
  contentType_is_null?: boolean | null;
  contentType_in?: (string | null)[] | null;
  contentType_not_in?: (string | null)[] | null;
  contentType_contains?: string | null;
  contentType_not_contains?: string | null;
  contentType_starts_with?: string | null;
  contentType_not_starts_with?: string | null;
  contentType_ends_with?: string | null;
  contentType_not_ends_with?: string | null;
  contentType_lt?: string | null;
  contentType_lte?: string | null;
  contentType_gt?: string | null;
  contentType_gte?: string | null;
  isUploaded?: boolean | null;
  isUploaded_not?: boolean | null;
  isUploaded_is_null?: boolean | null;
  isUploaded_in?: (boolean | null)[] | null;
  isUploaded_not_in?: (boolean | null)[] | null;
  createdAt?: GraphQL$DateTime | null;
  createdAt_not?: GraphQL$DateTime | null;
  createdAt_in?: GraphQL$DateTime[] | null;
  createdAt_not_in?: GraphQL$DateTime[] | null;
  createdAt_lt?: GraphQL$DateTime | null;
  createdAt_lte?: GraphQL$DateTime | null;
  createdAt_gt?: GraphQL$DateTime | null;
  createdAt_gte?: GraphQL$DateTime | null;
  updatedAt?: GraphQL$DateTime | null;
  updatedAt_not?: GraphQL$DateTime | null;
  updatedAt_in?: GraphQL$DateTime[] | null;
  updatedAt_not_in?: GraphQL$DateTime[] | null;
  updatedAt_lt?: GraphQL$DateTime | null;
  updatedAt_lte?: GraphQL$DateTime | null;
  updatedAt_gt?: GraphQL$DateTime | null;
  updatedAt_gte?: GraphQL$DateTime | null;
  isLegacy?: boolean | null;
  isLegacy_not?: boolean | null;
  isLegacy_is_null?: boolean | null;
  isLegacy_in?: (boolean | null)[] | null;
  isLegacy_not_in?: (boolean | null)[] | null;
  archive?: ArchiveWhereInput | null;
  category?: CategoryWhereInput | null;
  category_is_null?: boolean | null;
  photoMetadatas_some?: PhotoMetadataWhereInput | null;
  photoMetadatas8_some?: PhotoMetadata8WhereInput | null;
  photoMetadatas5059_some?: PhotoMetadata5059WhereInput | null;
  photoMetadatas5055_some?: PhotoMetadata5055WhereInput | null;
  photoMetadatas1_some?: PhotoMetadata1WhereInput | null;
  photoMetadatas5044_some?: PhotoMetadata5044WhereInput | null;
  photoMetadatas5020_some?: PhotoMetadata5020WhereInput | null;
  photoMetadatas5041_some?: PhotoMetadata5041WhereInput | null;
  photoMetadatas9_some?: PhotoMetadata9WhereInput | null;
  photoMetadatas5017_some?: PhotoMetadata5017WhereInput | null;
  photoMetadatas4_some?: PhotoMetadata4WhereInput | null;
  photoMetadatas5039_some?: PhotoMetadata5039WhereInput | null;
  photoMetadatas5025_some?: PhotoMetadata5025WhereInput | null;
  photoMetadatas5040_some?: PhotoMetadata5040WhereInput | null;
  photoMetadatas11_some?: PhotoMetadata11WhereInput | null;
  photoMetadatas6_some?: PhotoMetadata6WhereInput | null;
  photoMetadatas3_some?: PhotoMetadata3WhereInput | null;
  photoMetadatas2_some?: PhotoMetadata2WhereInput | null;
  photoMetadatas5019_some?: PhotoMetadata5019WhereInput | null;
  photoMetadatas5_some?: PhotoMetadata5WhereInput | null;
  photoMetadatas5033_some?: PhotoMetadata5033WhereInput | null;
  photoMetadatas5034_some?: PhotoMetadata5034WhereInput | null;
  photoMetadatas5012_some?: PhotoMetadata5012WhereInput | null;
  photoMetadatas5038_some?: PhotoMetadata5038WhereInput | null;
  photoMetadatas5036_some?: PhotoMetadata5036WhereInput | null;
  photoMetadatas5056_some?: PhotoMetadata5056WhereInput | null;
  photoMetadatas10_some?: PhotoMetadata10WhereInput | null;
  photoMetadatas5054_some?: PhotoMetadata5054WhereInput | null;
  photoMetadatas5052_some?: PhotoMetadata5052WhereInput | null;
  photoMetadatas5057_some?: PhotoMetadata5057WhereInput | null;
  photoMetadatas5032_some?: PhotoMetadata5032WhereInput | null;
  photoMetadatas5053_some?: PhotoMetadata5053WhereInput | null;
  photoMetadatas5043_some?: PhotoMetadata5043WhereInput | null;
  photoMetadatas7_some?: PhotoMetadata7WhereInput | null;
  photoMetadatas5048_some?: PhotoMetadata5048WhereInput | null;
  photoMetadatas5001_some?: PhotoMetadata5001WhereInput | null;
  photoMetadatas5060_some?: PhotoMetadata5060WhereInput | null;
  photoMetadatas5037_some?: PhotoMetadata5037WhereInput | null;
  photoMetadatas5051_some?: PhotoMetadata5051WhereInput | null;
  photoMetadatas5050_some?: PhotoMetadata5050WhereInput | null;
  AND?: PhotoWhereInput[] | null;
  OR?: PhotoWhereInput[] | null;
  NOT?: PhotoWhereInput | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
